import { createBrowserRouter } from "react-router";
import { AgencyArea, CreatorArea, PlatformArea, Start, ZahlungsmethodeArea } from "./layouts";
import { Go } from "./Go";
import { Anmelden } from "../pages/konto/Anmelden";
import { Sicherheit } from "../pages/konto/Sicherheit";
import { AdresseBestaetigen } from "../pages/konto/AdresseBestaetigen";
import { Uebersicht } from "../pages/agentur/Uebersicht";
import { Schnellstart } from "../pages/agentur/Schnellstart";
import { AgenturMehr } from "../pages/agentur/Mehr";
import { Hilfe, TicketDetail, TicketNeu } from "../pages/agentur/hilfe/Hilfe";
import { NichtGefunden } from "../pages/NichtGefunden";
import { rechnungenRoutes } from "../pages/agentur/rechnungen/routes";
import { kooperationenRoutes } from "../pages/agentur/kooperationen/routes";
import { Content } from "../pages/agentur/content/Content";
import { Hub } from "../pages/agentur/hub/Hub";
import { anfragenRoutes } from "../pages/agentur/anfragen/routes";
import { stammdatenRoutes } from "../pages/agentur/stammdaten/routes";
import { vertraegeRoutes } from "../pages/agentur/vertraege/routes";
import { einrichtungRoutes, einstellungenRoutes } from "../pages/agentur/einstellungen/routes";
import { kommunikationAgenturRoutes, kommunikationCreatorRoutes } from "../pages/kommunikation/routes";
import { creatorPublicRoutes, creatorRoutes } from "../pages/creator/routes";
import { unterCreatorRahmen } from "../pages/creator/rahmen";
import { oeffentlichRoutes } from "../pages/oeffentlich/routes";
import { unterschreibenRoutes } from "../pages/unterschreiben/routes";
import { betriebRoutes } from "../pages/betrieb/routes";
import { Postausgang } from "../pages/kommunikation/postausgang/Postausgang";
import { SpracheRahmen } from "./SpracheRahmen";
import { AppFehler } from "./AppFehler";

/**
 * Wege der App (docs/OBERFLAECHE_PLAN.md, Tabelle „Seiten und Wege“).
 * Jede Seitengruppe pflegt ihre Wege in ihrer eigenen routes.tsx; diese Datei setzt sie nur zusammen.
 */
export const router = createBrowserRouter([{
  // Abstürze beim Anzeigen fängt eine eigene Fehlerseite ab und meldet sie (0158)
  errorElement: <AppFehler />,
  children: [
    { path: "/", element: <Start /> },
    { path: "/anmelden", element: <Anmelden /> },
    { path: "/go/:kind/:id", element: <Go /> },
    // Ziel der Stripe-Mails „Zahlungsmethode aktualisieren“ (eigener Link in den Stripe-Einstellungen)
    { path: "/zahlungsmethode", element: <ZahlungsmethodeArea /> },
    // Eigenständige Seiten mit eigener Sprachwahl (PARITAET-8)
    // /bestaetigen: Ein-Klick-Link aus der Erinnerung an eine unbestätigte Registrierung (0243)
    { element: <SpracheRahmen />, children: [...einrichtungRoutes, { path: "/konto/sicherheit", element: <Sicherheit /> }, { path: "/bestaetigen", element: <AdresseBestaetigen /> }] },
    ...creatorPublicRoutes,
    ...oeffentlichRoutes,
    ...unterschreibenRoutes,
    {
      path: "/agentur",
      element: <AgencyArea />,
      children: [
        { index: true, element: <Uebersicht /> },
        // Aktivierungsplan Vertrieb 16.10.2026: Schnellstart, 3 Minuten (erster Creator, erste Kooperation, Beispieldaten)
        { path: "schnellstart", element: <Schnellstart /> },
        ...rechnungenRoutes,
        ...kooperationenRoutes,
        // Hub (21.10.2026): Marke, Kampagne, Kooperation und Creator mit dem Stand von Vertrag, Content und Rechnung an einem Ort
        { path: "hub", element: <Hub /> },
        // 0155: Content-Ablage
        { path: "content", element: <Content /> },
        ...anfragenRoutes,
        ...stammdatenRoutes,
        ...vertraegeRoutes,
        ...einstellungenRoutes,
        ...kommunikationAgenturRoutes,
        // Postausgang: nur Admins (Seite und Datenbank prüfen)
        { path: "postausgang", element: <Postausgang /> },
        // Handy: alle Bereiche, die in der unteren Leiste keinen Platz haben (SICHT-AGENTUR-GELD-9)
        { path: "mehr", element: <AgenturMehr /> },
        // 0176: Hilfe & Support (Tickets an den Betrieb, eigene Fehlermeldungen)
        { path: "hilfe", element: <Hilfe /> },
        { path: "hilfe/neu", element: <TicketNeu /> },
        { path: "hilfe/tickets/:id", element: <TicketDetail /> },
      ],
    },
    {
      path: "/creator",
      element: <CreatorArea />,
      // Ein Rahmen für alle Creator-Seiten: Sprache, Archiv-Sperre, Einführung (pages/creator/rahmen.tsx)
      children: unterCreatorRahmen([...creatorRoutes, ...kommunikationCreatorRoutes]),
    },
    { path: "/betrieb", element: <PlatformArea />, children: betriebRoutes },
    { path: "*", element: <NichtGefunden /> },
  ],
}]);
